<template>
  <div>
    <div class="modal fade" id="trsCancelModal" tabindex="-1" role="dialog" aria-labelledby="trsCancelModalLabel" aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p>
              各種規定や確認事項にすべて承諾または「はい」をご選択いただきますと、取引画面へ進めます。
            </p>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="hideCancelModal">閉じる</button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="trsLendModal">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h4 class="modal-title">名義貸し・借名口座について</h4>
          </div>
          <div class="modal-body">
            <p>
              家族や知人に依頼されご自身の名義を他人に貸して口座開設を行うことや、第三者にご自身の名義で開設した口座を譲り渡すことは、脱税やマネーロンダリングの温床となる可能性があり、法令諸規則で禁止されております。また、名義貸しによって第三者が行った取引にて発生した損益に対する税金や不足金の返済義務はすべてご自身が負うことになります。名義貸しによる口座開設は絶対に行わないでください。
            </p>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-primary" data-dismiss="modal">
              閉じる
            </button>
          </div>
        </div>
      </div>
    </div>

    <div class="modal fade" id="trsPepModal">
    <div class="modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                <h4 class="modal-title" id="">外国PEPsについて</h4>
            </div>
            <div class="modal-body">
                <div class="form-group txt-left">
                    以下の項目のいずれかに該当する場合は、外国PEPsに該当します。
                </div>
                <div class="form-group txt-left">
                    <p>1.外国の元首及び過去外国元首であった者</p>
                    <p>
                        2.外国政府等で重要な地位を占める者として以下に該当する者及び過去に当該地位であった者
                    <ul style="list-style: initial; padding-left: 40px;">
                        <li>日本における内閣総理大臣その他国務大臣及び副大臣に相当する職</li>
                        <li>日本における衆議院議長、衆議院副議長、参議院議長又は参議院副議長に相当する職</li>
                        <li>日本における最高裁判所の裁判官に相当する職</li>
                        <li>日本における特命全権大使、特命全権公使、特派大使、政府代表又は全権委員に相当する職</li>
                        <li>日本における統合幕僚長、統合幕僚副長、陸上幕僚長、陸上幕僚副長、海上幕僚長、海上幕僚副長、航空幕僚長又は航空幕僚副長に相当する職</li>
                        <li>中央銀行の役員</li>
                        <li>予算について国会の議決を経、又は承認を受けなければならない法人の役員</li>
                    </ul>
                    </p>
                    <p>3.上記に掲げる者の家族（配偶者(事実婚を含む)、父母、子、兄弟姉妹、並びに、これらの者以外の父母及び子）</p>
                </div>
                <div class="modal-footer">
                    <a type="button" @click="hidePepModal" class="btn btn-primary" alt="閉じる" title="閉じる">閉じる</a>
                </div>
            </div>
        </div>
    </div>
</div>


  </div>
</template>

<script>
import ModalPlugin from "@/common/plugins/ModalPlugin.js";
import jquery from "jquery";

const $ = jquery.noConflict();
export default {
    name: "AgreementNewsModal",
    mounted() {
        ModalPlugin.EventBus.$on(this.IConstants.EVENT_NAME.SHOW_AGREEMENT_NEWS_MODAL, (options) => {
            this.show(options);
        });
    },
    methods: {
        show(options) {
            const {type} = options;
            if (type) {
                if (type === this.IConstants.AGREEMENT_NEWS_MODAL_TYPE.CANCEL) {
                    $("#trsCancelModal").modal("show");
                } else if (type === this.IConstants.AGREEMENT_NEWS_MODAL_TYPE.LEND) {
                    $("#trsLendModal").modal("show");
                } else if (type === this.IConstants.AGREEMENT_NEWS_MODAL_TYPE.PEP) {
                    $("#trsPepModal").modal("show");
                }
            }
        },
        hideCancelModal() {
            $("#trsCancelModal").modal("hide");
        },
        hideLendModal() {
            $("#trsLendModal").modal("hide");
        },
        hidePepModal() {
            $("#trsPepModal").modal("hide");
        },
        onConfirm() {
            ModalPlugin.EventBus.$emit("onFinish", 5);
        }
    },
};
</script>

<style scoped>
.modal-header {
  flex-direction: column;
}
.news-date {
  margin-right: 5px;
}
.modal-dialog{
    max-width: 600px !important;
}
</style>
